import { v4 as uuid } from 'uuid';
import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import { epoch, utc } from '../../util/datetime';
import Address from '../address/Address';
import type { IOtherAdviser } from './OtherAdviser.interface';
import { OtherAdviserType } from './OtherAdviser.enum';
import { PersonalTitle } from '../global/PersonalTitle.enum';

export default class OtherAdviser implements IOtherAdviser {
  id: string;
  otherAdviserType: OtherAdviserType;
  companyName: string;
  bankBranch: string;
  contactTitle: PersonalTitle;
  contactFirstName: string;
  contactLastName: string;
  contactPhoneCode: string;
  contactPhone: string;
  contactEmail: string;
  address: Address;
  idAsset: string;
  idContacts: Array<string>;
  idEmployers: Array<string>;
  idInsurance: Array<string>;
  timeStamp: number;
  isActive: boolean;

  getName() {
    return this.name;
  }

  isOtherAdviserAccountantType() {
    return this.otherAdviserType.id === OtherAdviser.getAvailableOtherAdviserTypes()[0].id;
  }

  isOtherAdviserSolicitorType() {
    return this.otherAdviserType.id === OtherAdviser.getAvailableOtherAdviserTypes()[1].id;
  }

  isOtherAdviserRealEstateType() {
    return this.otherAdviserType.id === OtherAdviser.getAvailableOtherAdviserTypes()[2].id;
  }

  isOtherAdviserFinancialAdvisorType() {
    return this.otherAdviserType.id === OtherAdviser.getAvailableOtherAdviserTypes()[3].id;
  }

  isOtherAdviserGeneralInsuranceAgentType() {
    return this.otherAdviserType.id === OtherAdviser.getAvailableOtherAdviserTypes()[4].id;
  }

  isOtherAdviserPrimaryBankerType() {
    return this.otherAdviserType.id === OtherAdviser.getAvailableOtherAdviserTypes()[5].id;
  }

  static getAvailableOtherAdviserTypes = () => OtherAdviserType.available();

  static build = (data: IOtherAdviser) => new OtherAdviser(data);
  static blank = (otherAdviserType: OtherAdviserType) =>
    new OtherAdviser({ id: uuid(), otherAdviserType, isActive: true });

  /**
   * Constructor
   * @param {IOtherAdviser} data
   */
  constructor(data?: IOtherAdviser) {
    this.id = toUUID(data?.id) || uuid();
    this.otherAdviserType = OtherAdviserType.of(
      data?.otherAdviserType?.id || data?.otherAdviserType?.name
    );
    this.companyName = data?.companyName || '';
    this.bankBranch = data?.bankBranch || '';
    this.contactTitle = PersonalTitle.of(
      data?.contactTitle?.name || data?.contactTitle?.toString()
    );
    this.contactFirstName = data?.contactFirstName || '';
    this.contactLastName = data?.contactLastName || '';
    this.contactPhoneCode = data?.contactPhoneCode || '';
    this.contactPhone = data?.contactPhone || '';
    this.contactEmail = data?.contactEmail || '';
    this.address = new Address(data.address);
    this.idAsset = toUUID(data?.idAsset);
    this.idContacts = compact(map(data?.idContacts, (obj) => toUUID(obj)));
    this.idEmployers = compact(map(data?.idEmployers, (obj) => toUUID(obj)));
    this.idInsurance = compact(map(data?.idInsurance, (obj) => toUUID(obj)));
    this.timeStamp = epoch(utc(data?.timeStamp));
    this.isActive = data?.isActive === true;
  }
}
